const origin = window.location.origin;
const casURL = process.env.VUE_APP_CAS_URL;
const clientId = process.env.VUE_APP_CAS_CLIENT_ID

export const dealerNetMap = new Map([
  [1, 'dealerNet_wcw'],
  [2, 'dealerNet_hyw'],
])
export const goCas = (queryUrl = '') => {
  const href = `${casURL}/cas/oauth2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(`${origin}/#/casLogin?query=${queryUrl ? encodeURIComponent(queryUrl) : ''}`)}`
  window.location.href = href;
}

// ?service=${encodeURIComponent(`${origin}/#/casLogin?query=`)}
export const casLogout = () => {
  const href = `${casURL}/cas/logout`
  window.location.href = href;
}